import AddRequisitionsCont from '../../components/Corporate/Requisitions/AddRequisitions/AddRequisitionsCont'
import AddCargoCont from '../../components/Purchasing/Cargo/AddCargo/AddCargoCont'
import CargoCont from '../../components/Purchasing/Cargo/CargoCont'
import AddDeliveryOrderCont from '../../components/Purchasing/DeliveryOrder/AddDeliveryOrder/AddDeliveryOrderCont'
import DeliveryOrderCont from '../../components/Purchasing/DeliveryOrder/DeliveryOrderCont'
import ReadyToOrderCont from '../../components/Purchasing/Order/ReadyToOrderCont'
import UpdateOrderCont from '../../components/Purchasing/Order/UpdateOrderCont'
import AddPackageCont from '../../components/Purchasing/Packages/AddPackage/AddPackageCont'
import PackageCont from '../../components/Purchasing/Packages/PackageCont'
import Remittance from '../../components/Purchasing/Remittance/RemittanceCont'
import StockCont from '../../components/Purchasing/Stock/StockCont'
import VendorQuotesCont from '../../components/Purchasing/VendorQuotes/VendorQuotesCont'
import VouchersCont from '../../components/Purchasing/Voucher/VouchersCont'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import SupplierCont from '../../components/Purchasing/Supplier/SupplierCont'
import PurchasingDashboard from '../../components/Purchasing/Dashboard'
import SupplierRegistrationCont from '../../components/Purchasing/SupplierRegistration/SupplierRegistrationCont'
import SupplierRegistrationApprovalCont from '../../components/Purchasing/SupplierRegistration/SupplierRegistrationApprovalCont'
import RFQ from '../../components/Purchasing/RFQ/RFQCont'
import Requisitions from '../../components/Corporate/Requisitions/Requisitions'
import AddRemittanceCont from '../../components/Purchasing/Remittance/AddRemittance/AddRemittanceCont'
import AddVoucherCont from '../../components/Purchasing/Voucher/AddVoucher/AddVoucherCont'
import AddRFQCont from '../../components/Purchasing/RFQ/AddRFQ/AddRFQCont'
import AddVendorQuoteCont from '../../components/Purchasing/VendorQuotes/AddVendorQuote/AddVendorQuoteCont'
import SupplierList from '../../components/Purchasing/SupplierList'
import NewSupplier from '../../components/Purchasing/NewSupplier/NewSupplier'
import AddContractCont from '../../components/Purchasing/Supplier/Contract/AddContract/AddContractCont'
import ViewContractCont from '../../components/Purchasing/Supplier/Contract/ViewContract/ViewContractCont'
import NoMatchComponent from '../../components/NoMatch'

export default function ClientRouter(props) {
  const url = props.match.url
  return (
    <Switch>
      <Route path={`${url}/dashboard`} component={PurchasingDashboard} />

      {/*<Route path={`${url}/mrn/:key/update`} component={AddMRNCont}/>*/}
      {/*<Route path={`${url}/mrn/new`} component={AddMRNCont}/>*/}
      <Route path={`${url}/stock`} component={StockCont} />

      <Route path={`${url}/delivery/:key/update`} component={AddDeliveryOrderCont} />
      <Route path={`${url}/delivery/new`} component={AddDeliveryOrderCont} />
      <Route path={`${url}/delivery`} component={DeliveryOrderCont} />

      <Route path={`${url}/packages/:key/update`} component={AddPackageCont} />
      <Route path={`${url}/package/new`} component={AddPackageCont} />
      <Route path={`${url}/package`} component={PackageCont} />

      <Route path={`${url}/cargo/:key/update`} component={AddCargoCont} />
      <Route path={`${url}/cargo/new`} component={AddCargoCont} />
      <Route path={`${url}/cargo`} component={CargoCont} />

      <Route path={`${url}/suppliers/list`} component={SupplierList} />
      <Route path={`${url}/suppliers/new`} component={NewSupplier} />

      <Route path={`${url}/rfq/:key/update`} component={AddRFQCont} />
      <Route path={`${url}/rfq/new`} component={AddRFQCont} />
      <Route path={`${url}/rfq`} component={RFQ} />
      <Route path={`${url}/remittance/:key/update`} component={AddRemittanceCont} />
      <Route path={`${url}/remittance/new`} component={AddRemittanceCont} />
      <Route path={`${url}/remittance`} component={Remittance} />
      <Route path={`${url}/vouchers/:key/update`} component={AddVoucherCont} />
      <Route path={`${url}/vouchers/new`} component={AddVoucherCont} />
      <Route path={`${url}/vouchers`} component={VouchersCont} />
      <Route path={`${url}/vendor/quotes/:key/update`} component={AddVendorQuoteCont} />
      <Route path={`${url}/vendor/quotes/new`} component={AddVendorQuoteCont} />
      <Route path={`${url}/vendor/quotes`} component={VendorQuotesCont} />

      <Route path={`${url}/requisitions/:key/update`} component={AddRequisitionsCont} />
      <Route path={`${url}/requisitions/new`} component={AddRequisitionsCont} />
      <Route path={`${url}/requisitions/`} component={Requisitions} />

      <Route
        path={`${url}/suppliers/registration/:key`}
        component={SupplierRegistrationApprovalCont}
      />
      <Route path={`${url}/suppliers/registration`} component={SupplierRegistrationCont} />
      <Route path={`${url}/suppliers/:key/contracts/new`} component={AddContractCont} />
      <Route
        path={`${url}/suppliers/:key/contracts/:contractKey/update`}
        component={AddContractCont}
      />
      <Route
        path={`${url}/suppliers/:key/contracts/:contractKey/view`}
        component={ViewContractCont}
      />

      <Route path={`${url}/order/:key/update`} component={UpdateOrderCont} />
      <Route path={`${url}/order/`} component={ReadyToOrderCont} />

      <Route path={`${url}/suppliers/:key/`} component={SupplierCont} />
      <Route component={NoMatchComponent} />
    </Switch>
  )
}
